import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon_thumbsup.svg'


const _withScopeId = n => (_pushScopeId("data-v-9c09d972"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container",
  id: "infoContainer"
}
const _hoisted_2 = {
  key: 0,
  class: "row",
  id: "titleSection"
}
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { id: "title" }
const _hoisted_5 = {
  class: "row",
  id: "voteSection"
}
const _hoisted_6 = { class: "voteWrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"display":"inline-block","height":"20px"},
  src: _imports_0
}, null, -1))
const _hoisted_8 = { style: {"margin-bottom":"0","margin-left":"5px","display":"inline-block"} }
const _hoisted_9 = {
  class: "row",
  id: "statisticSection"
}
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "statistic" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "statistic" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "statistic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "col",
        id: "upvotes",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.vote && _ctx.vote(...args)))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.t("like")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t("views", _ctx.views)), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t("downloads", _ctx.downloads)), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.t("shares", _ctx.shares)), 1)
      ])
    ])
  ]))
}